import { formatISOToThaiDate } from 'react-lib/utils/dateUtils';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Segment } from 'semantic-ui-react';
import "./WalletCreditLabel.scss"

// Component
import MeHealthHistoryModal from 'react-lib/apps/MEH/MeHealthHistoryModal';

type WalletCreditLabelrops = {
  BillingAndPackageSequence: any;
  BillingCreditWallet: any;
  runSequence: any;
  controller: any;
  setProp: any;
  selectedDivisionId?: string;
}

const WalletCreditLabel = (props: WalletCreditLabelrops) => {
  const [openHistory, setOpenHistory] = useState<boolean>(false);

  useEffect(() => {

    if (props.BillingAndPackageSequence?.sequenceIndex === "Action") {
      props.runSequence({ sequence: "BillingAndPackage", action: "GET_CREDIT_WALLET" });
    }

  }, [props.BillingAndPackageSequence?.sequenceIndex, props.selectedDivisionId])

  const handleOpenHistory = () => {
    props.runSequence({ sequence: "BillingAndPackage", action: "GET_CREDIT_WALLET" });

    setOpenHistory(true);
  };

  let updateAt = props.BillingCreditWallet?.balance_updated_at ? formatISOToThaiDate(props.BillingCreditWallet?.balance_updated_at) : ""

  return (
    <>
      <MeHealthHistoryModal
        open={openHistory}
        onClose={() => setOpenHistory(false)}
        // Main Props
        BillingAndPackageSequence={props.BillingAndPackageSequence}
        runSequence={props.runSequence}
        setProp={props.setProp}
        BillingCreditWallet={props.BillingCreditWallet}
      />

      <div id="WalletCreditLabel" onClick={handleOpenHistory}>
        {/* Left Section */}
        <div className="credit-balance-left">
          <div className="credit-balance-label">ยอดคงเหลือ</div>
          <div className="credit-balance-timestamp">{updateAt ?? ""}</div>
        </div>

        <div className="credit-balance-amount">
          {props.BillingCreditWallet?.balance
            ? Number(props.BillingCreditWallet.balance).toLocaleString(undefined, { minimumFractionDigits: 2 })
            : "0.00"}
        </div>

        {/* Right Section */}
        <div className="credit-balance-right">

          <div className="credit-balance-text">Credit</div>
        </div>
      </div>
    </>
  );
};

export default WalletCreditLabel;

// style={{ width: '190px', height: '60px' }} onClick={() => {
//    props.setProp("BillingAndPackageSequence", {
//      ...props.BillingAndPackageSequence,
//      openTransactionModal: true
//    })
// }